import { drawerAnatomy } from '@chakra-ui/anatomy';

export const DRAWER_PARTS = [
  ...drawerAnatomy.keys,
  'overline',
  'headerActions',
] as const;
